import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultConnections,
  defaultConstruction,
  defaultContactInfo,
  defaultCosts,
  defaultDescription,
  defaultHangarBasicInfo,
  defaultHangarOtherFacilities,
  useManualAndInternationalAddress,
} from '../../../../../services/validation/flow/defaultSchemas'

export const propertyOwnerHangarRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: defaultHangarBasicInfo,
  costs: defaultCosts,
  description: defaultDescription,
  contactInfo: defaultContactInfo,
  otherFacilities: defaultHangarOtherFacilities,
  connections: defaultConnections,
  construction: defaultConstruction,
}
